module.exports = __webpack_public_path__ + "static/media/black-polo-shirt.2864a1ba.jpg";